import Icon from '@ant-design/icons'
import * as React from 'react'

import { NovaIconProps } from '../types/iconTypes'

const Contract = (props: NovaIconProps) => (
  <Icon
    {...props}
    component={() => (
      <svg
        width="1em"
        height="1em"
        focusable={false}
        viewBox="2 2 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.7071 4.70711C29.0976 4.31658 29.0976 3.68342 28.7071 3.29289C28.3166 2.90237 27.6834 2.90237 27.2929 3.29289L20 10.5858L20 6C20 5.44771 19.5523 5 19 5C18.4477 5 18 5.44771 18 6L18 12C18 13.1046 18.8954 14 20 14H26C26.5523 14 27 13.5523 27 13C27 12.4477 26.5523 12 26 12H21.4142L28.7071 4.70711ZM12 26C12 26.5523 12.4477 27 13 27C13.5523 27 14 26.5523 14 26L14 20C14 18.8954 13.1046 18 12 18L6 18C5.44772 18 5 18.4477 5 19C5 19.5523 5.44772 20 6 20H10.5858L3.29289 27.2929C2.90237 27.6834 2.90237 28.3166 3.29289 28.7071C3.68342 29.0976 4.31658 29.0976 4.70711 28.7071L12 21.4142L12 26Z"
          fill="currentColor"
        />
      </svg>
    )}
  />
)

export default Contract
